import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import './sideNav.css';

const SideNavItems = ({ user }) => {
  const items = [
    {
      type:'navItem',
      icon:'fas fa-walking',
      text:'Trainers',
      link:'/trainer',
      restricted:true
    },
    {
      type:'navItem',
      icon:'fas fa-dumbbell',
      text:'Workouts',
      link:'/workout',
      restricted:true,
      edit: true
    },
    {
      type:'navItem',
      icon:'fas fa-dumbbell',
      text:'Workouts Videos',
      link:'/workoutVideos',
      restricted:true,
      edit: true
    },
    {
      type:'navItem',
      icon:'fas fa-dumbbell',
      text:'Skills',
      link:'/skills',
      restricted:true,
    },
    {
      type:'navItem',
      icon:'fas fa-dumbbell',
      text:'Exercises',
      link:'/exercise',
      restricted:true,
      edit: true
    },
    {
      type:'navItem',
      icon:'fas fa-comments',
      text:'Feedbacks',
      link:'/feedback',
      restricted:true,
      edit: true
    },
    {
      type:'navItem',
      icon:'fas fa-comments',
      text:'Motivation Feedback',
      link:'/motivationFeedback',
      restricted:true
    }, 
    {
      type:'navItem',
      icon:'users',
      text:'Users',
      link:'/users',
      restricted:true
    },
    {
      type:'navItem',
      icon:'users',
      text:'Free User',
      link:'/updateUser',
      restricted:true
    },
    {
      type:'navItem',
      icon:'balance-scale',
      text:'Measureents',
      link:'/measurements',
      restricted:true
    },
    {
      type:'navItem',
      icon:'sort-numeric-up-alt',
      text:'Numbers',
      link:'/numbers',
      restricted:true
    },
    {
      type:'navItem',
      icon:'sign-in-alt',
      text:'Login',
      link:'/login',
      restricted:false,
      exclude:true
    },
    {
      type:'navItem',
      icon:'video',
      text:'Dataset Samples',
      link:'/dataset',
      restricted:true,
      algo: true
    },
    {
      type:'navItem',
      icon:'sign-out-alt',
      text:'Logout',
      link:'/logout',
      restricted:true,
      edit: true,
      algo: true
    }
  ]

  const element = (item, i) => (
    <div key={i} className={item.type}>
      <Link to={item.link} className={item.type}>
        <div className="inline">
          <FontAwesome name={item.icon} className="fa-2x fontawsome" />
          <p className="sidenav-item-text">{item.text}</p>
        </div>
      </Link>
    </div>
  )

  const showItems = () => (
    user.login ? 
      items.map((item, i) => {
        if(user.login.isAuth){
          if(user.login.role === 'EDIT') {
            return !item.exclude && item.edit ? 
              element(item, i) 
            : null
          } else if(user.login.role === 'ALGO') {
            return !item.exclude && item.algo ? 
              element(item, i) 
            : null
          } else{
            return !item.exclude ? 
            element(item, i) 
           : null
          }
        } else {
          return !item.restricted ?
            element(item, i) 
          :null
        }
      })
    : null
  )

  return (
    <div>
      {showItems()}
    </div>
  )
}

function mapStateToProps (state) {
  return {
   user: state.login
  }
}
export default connect(mapStateToProps)(SideNavItems);